(function () {
  var mySwiper = new Swiper("#mv .swiper-fade", {
    slidesPerView: 1,
    spaceBetween: 0,
    effect: "fade",
    centeredSlides: true,
    speed: 2000,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
      waitForTransition: false,
    }
  });

  var mySwiper = new Swiper("#mv .swiper-container", {
    slidesPerView: 1,
    spaceBetween: 0,
    effect: "fade",
    centeredSlides: true,
    speed: 2000,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
      waitForTransition: false,
    },
  });

  var mySwiper = new Swiper("#lineup .swiper-container", {
    slidesPerView: 1,
    spaceBetween: 50,
    loop: true,
    effect: "slide",
    pagination: {
      el: "#lineup .swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: "#lineup .swiper-button-next",
      prevEl: "#lineup .swiper-button-prev",
    },
  });

  function setupToggle() {
    if ($('.js-toggle').length === 0) return;

    $('.js-toggle').each(function(i, v) {
      const $wrapper = $(this),
        $trigger = $wrapper.children('.js-toggleTrigger'),
        $box = $wrapper.children('.js-toggleContent');
        
      if ($wrapper.hasClass('js-isOpen')) {
        $trigger.next().show();
      }

      $trigger.on('click', function(e, _speed) {
        const speed = (_speed !== undefined ? _speed : 300);
        $wrapper.toggleClass('js-isOpen');
        $box.stop(false, true).slideToggle(speed);
      });
    });
  }

  $(window).on("resize", function () {
    setupToggle();
  });

  $(function() {
    setupToggle();
  });
})();
